import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import StoreFranchiseIndicator$1 from './StoreFranchiseIndicator.js';

const StoreFranchiseIndicatorContainer = ()=>{
    const { getFormattedLabel  } = useIntl();
    const label = getFormattedLabel('stores.page.details.franchiseStoreIndicator', {
        parseLink: true
    });
    return /*#__PURE__*/ React__default.createElement(StoreFranchiseIndicator$1, {
        label: label
    });
};
var StoreFranchiseIndicator = StoreFranchiseIndicatorContainer;

export { StoreFranchiseIndicator as default };
//# sourceMappingURL=StoreFranchiseIndicatorContainer.js.map
